//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { createContext } from 'react';

// -----------------------------------------------------------------------
// LLM context value — the active-LLM selection.  activeLLM is computed from the
// saved preference + appConfig.llm_config (see LLMProvider); setActiveLLM is the
// canonical setter — it validates against the configured models and persists to
// the profile.  The LLM call methods (callLLM, inferSchema, getCypherFromQuestion)
// live in useLLMActions as stateless service calls.
// -----------------------------------------------------------------------

export interface LLMContextValue {
  activeLLM: string;
  setActiveLLM: (llm: string) => Promise<void>;
}

const LLMContext = createContext<LLMContextValue | null>(null);

export { LLMContext };
